<template>
      <div class="litem">
        <div class="leftbar" >
            <Menu class="channel out" style="z-index:800;">
                <MenuGroup v-for="(i,ix) in userMenu.menu" :title="i.name" :key="ix" class="channelTitle">
                    <MenuItem v-for="(j,jx) in verify(i.submenu)" :name="j.name" :key="jx" class="contentItem" @click.native="gotoTab(j.to,j.name);j.count=0;">
                        <span :is="j.is||'span'" dot :count="j.count||0">
                            {{j.name}}
                        </span>
                    </MenuItem>
                </MenuGroup>
            </Menu>
        </div>
        <div class="rightbar">
            <Tabs :animated="false" type="card" :beforeRemove="beforRemove" @on-tab-remove="handleTabRemove" ref="userTabs" class="out" style="padding:.5em;">
                <TabPane v-for="(i,ix) in tabList" :label="labelRender(i)" :id="i.component" :key="ix" :index="ix" :closable="tabList.length>1?true:false">
                    <div :is="i.component">{{i.label}}</div>
                </TabPane>
            </Tabs>
        </div>
      </div>
</template>
<style scoped>
.lpage{flex-direction: row;}
div.litem{
    width:100%;
    flex-direction: row;
    color:#000;
    padding:1%;
}
.leftbar{
    min-width:150px;width:20%;flex:1;
    }
.rightbar{flex:4;border-radius:0.3em;width:75%;max-width:75%;}
@media (max-width: 900px){
    .leftbar{width:96%;max-width:480px;}
    .rightbar{width:96%;max-width:100%;}
    div.litem{flex-direction:column;}
    #cmsContent{max-width:10rem;}
}
.channel{display:flex;flex-direction:column;border-radius:0.3em;box-shadow: rgba(0,0,0,0.2) 0 0 0.3em;padding:0.5em;}
.channelTitle{border-radius:0.3em 0.3em 0 0;padding:0.2em;color:#515a6e;}
.contentTag{color:#999;padding:0.2em;display:flex;flex-direction:column;}
.contentItem{padding:0.5em 0.5em 0.5em 1em;color:#515a6e;}
.cmsSelected{padding-left:1.5em;color:darkgoldenrod;}
table{border-radius: 0.3em;padding:0.3em; table-layout:fixed;width:100%;}
td{padding:5px 2px 5px 2px;
border:1px solid #eeeeee;}
.odd{font-weight:bold}
.item{color:#ffffff;background:#8db7e1;padding: 1em 0.4em 1em 0.8em;font-weight: bold;font-size:18px;border-radius:10px 10px 0 0;}
.out{transition:400ms ease;}
.out:hover{box-shadow:0 0 5px #00aadd;}
.sub{max-height: 2000px;overflow: hidden;transition: max-height 1s ease; }
@keyframes aniBlink120{from{margin-left:-120px}to{margin-left:330px}}
@-webkit-keyframes aniBlink120{from{margin-left:-120px}to{margin-left:330px}}
.overimg{position:relative;overflow:hidden;margin:0 auto}
.overimg a{display:inline-block}
.overimg a:before{content:'';position:absolute;width:60px;height:600px;margin-top:0px;margin-left:-150px;overflow:hidden;z-index:6;background:-moz-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,0.4) 50%,rgba(255,255,255,0) 100%);background:-webkit-gradient(linear,left top,right top,color-stop(0%,rgba(255,255,255,0)),color-stop(50%,rgba(255,255,255,0.4)),color-stop(100%,rgba(255,255,255,0)));background:-webkit-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,0.4) 50%,rgba(255,255,255,0) 100%);background:-o-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,0.4) 50%,rgba(255,255,255,0) 100%);-webkit-transform:skewX(-25deg);transform:skewX(-25deg)}
.overimg:hover a:before{
	-webkit-animation:aniBlink120 .32s ease-out forwards;
	-moz-animation:aniBlink120 .32s ease-out forwards;
	-o-animation:aniBlink120 .32s ease-out forwards;
	animation:aniBlink120 .32s ease-out forwards
}
</style>
<style>
    div.ivu-tabs-nav-scrollable{padding:0 20px;}
</style>
<script>
export default {
  data(){
      let userMenu={}
      userMenu.menu=[
          {name:'我的账户',to:'userinfoManage',submenu:[{name:'个人信息',to:'userInfo'},{name:'修改密码',to:'modiPassword'},{name:'成员管理',to:'departmentUsers',level:3},{name:'我的消息',to:'messages',is:'Badge',}]},
          {name:'预约管理',to:'appointManage',submenu:[{name:'预约查询',to:'appointments'},{name:'待办事项',to:'backlog',is:'Badge',level:4},{name:'使用记录',to:'record',level:4}]}, 
          //{name:'消费管理',to:'/consumeManage',submenu:[{name:'消费记录',to:'/consumes'}]},
      ]
      return{
        userMenu,
        tabList:[],
        shrink:false,
        
      }
  },
  beforeCreate(){
    if (!this.$store.state.user.id){this.$router.go(-1);}
  },
  created(){
      if ((this.$store.state.user.lab_role >=255) && !this.userMenu){
          window.location.href="https://biocore.sjtu.edu.cn/meetingRoom/admin"
          return
      }
      setTimeout(()=>{this.tabList.push({component:'userInfo',label:'个人信息'})},200)
      this.init()
  },
  components: {
      userInfo:()=>import('./userInfo.vue'),
      modiPassword:()=>import('./modiPassword.vue'),
      appointments:()=>import('./appointments.vue'),
      departmentUsers:()=>import('./departmentUsers.vue'),
      record:()=>import('./record.vue'),
      backlog:()=>import('./backlog.vue'),
      messages:()=>import('./messages.vue'),
  },
  watch: {
    '$route' (to,fr) {
        console.log(to.fullPath,fr.fullPath)
        this.init()
    }
  },
mounted:function(){
        if (this._isMobile()||document.body.clientWidth<900){this.toggleList()}
    },
  methods:{
      init(){
          //scrollTo(0,0)
          if (Object.keys(this.$route.params).length==0){
              let p=this.$store.state.routerViews.menuLevel
              for (let i in p){this.$route.params[i]=p[i]}
          }
      },
    toggleList(){
        if($('.sub').css('max-height')=='0px')$('.sub').css('max-height','1000px')
        else $('.sub').css('max-height','0')
    },
    gotoTab(t,n){
        let index=this.tabList.findIndex(i=>i.component == t)
        if(index==-1){
            this.tabList.push({component:t,label:n})
            setTimeout(()=>this.$refs.userTabs.handleChange(this.tabList.length-1),200)
            return
        }
        console.log('[changeTab]',this.$refs.userTabs.handleChange(index<0?this.tabList.length-1:index))
    },
    beforRemove(n){
        this.$delete(this.tabList,n)
        return 
    },
    handleTabRemove(n){
        console.log('[removeTab]',n,this.tabList)
        //this.$delete(this.tabList,n)
    },
    labelRender:function(i){
        let _this=this
        return (h)=>{
            return h('div',{},[
                h('span',{},i.label||'label'),
                h('Icon',{
                    props:{type:'ios-close'},style:{color:'#a32',marginLeft:'6px',marginRight:'-6px'},on:{click:()=>{let n=_this.tabList.findIndex(j=>j.component==i.component);_this.$delete(_this.tabList,n);_this.$refs.userTabs.handleChange(n?n-1:0)}},
                },),
            ],)}
    },
    verify(s){
        return s.filter((i)=>{return !i.level || i.level==this.$store.state.user.id})
    },
  }
}
</script>